import type { ReactNode } from "react";

// 分类标签配色
const CAT_TONE: Record<string, string> = {
  ta: "bg-primary-500/90 text-background-50",
  fan: "bg-accent-500 text-background-50",
  lian: "bg-secondary-500 text-background-50",
  zong: "bg-background-100 text-foreground-700 border border-background-200",
  drama: "bg-background-100 text-foreground-700 border border-background-200",
  music: "bg-background-100 text-foreground-700 border border-background-200",
};

export function CategoryChip({ label, toneKey }: { label: string; toneKey?: string }) {
  const cls =
    (toneKey && CAT_TONE[toneKey]) ||
    "bg-background-100 text-foreground-700 border border-background-200";
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium leading-5 ${cls}`}
    >
      {label}
    </span>
  );
}

export function HotTag({ label, tone }: { label: string; tone?: "hot" | "boom" | "new" }) {
  const map = {
    hot: "text-primary-600 bg-primary-50 border border-primary-200",
    boom: "bg-primary-500 text-background-50",
    new: "text-accent-700 bg-accent-100 border border-accent-200",
  };
  const cls = map[tone || "hot"];
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-bold leading-4 ${cls}`}
    >
      {label}
    </span>
  );
}

export function SectionHead({
  eyebrow,
  title,
  desc,
  anchor,
  align = "left",
}: {
  eyebrow?: string;
  title: ReactNode;
  desc?: string;
  anchor?: string;
  align?: "left" | "center";
}) {
  return (
    <div
      className={`mb-7 md:mb-9 ${align === "center" ? "text-center mx-auto max-w-2xl" : ""}`}
    >
      {eyebrow ? (
        <div
          className={`mb-2 flex items-center gap-2 text-sm font-semibold tracking-wide ${
            align === "center" ? "justify-center" : ""
          }`}
        >
          <span className="inline-block h-5 w-1 rounded-full bg-primary-500" />
          <span className="text-primary-600">{eyebrow}</span>
        </div>
      ) : null}
      {anchor ? (
        <h2 id={anchor} className="font-heading text-2xl font-black leading-tight text-foreground-950 md:text-[32px]">
          {title}
        </h2>
      ) : (
        <h3 className="font-heading text-2xl font-black leading-tight text-foreground-950 md:text-[28px]">
          {title}
        </h3>
      )}
      {desc ? (
        <p className={`mt-2 text-sm leading-6 text-foreground-600 md:text-base ${align === "center" ? "mx-auto" : "max-w-2xl"}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}